export default __webpack_public_path__ + "static/webRotator/svg/f5ccfbf49bbc990a42111ea14e59b3e4.svg";